<template>
    <BaseChip size="2xs" class="self-start text-ink-muted" :class="{ 'h-5 gap-1': appearance === 'journey' }">
        <template #leading><i class="bi" :class="[presentation.icon, { 'text-[10px]': appearance === 'journey' }]" aria-hidden="true"></i></template>
        {{ presentation.label }}
    </BaseChip>
</template>

<script setup lang="ts">
import BaseChip from "~vue/components/BaseChip.vue";
import { getWeeklyActionModePresentation, getWeeklyActionTaxonomyPresentation } from "~vue/pages/developmentJourneys/weeklyActionPresentation";
import type { WeeklyActionChannel } from "~vue/pages/developmentJourneys/weeklyActions";
import { computed } from "vue";

const {
    channel,
    appearance = "default",
    labelMode = "type",
} = defineProps<{
    channel: WeeklyActionChannel;
    appearance?: "default" | "journey";
    labelMode?: "type" | "participation";
}>();
const presentation = computed(() => (labelMode === "participation" ? getWeeklyActionModePresentation(channel) : getWeeklyActionTaxonomyPresentation(channel)));
</script>
